import { Deserializable } from '../protocols/deserializable';
import { BaseType } from '../base/base-type';

export class VbRecurringPaymentInstruction implements Deserializable {
  public id!: string;
  public paymentStartDate!: string;
  public endDate!: string | null;
  public paymentFrequencyId!: number;
  public paymentFrequency!: BaseType;
  public useMinimumAmount!: boolean;
  public useMaximumAmount!: boolean;
  public paymentAmount!: number;

  public onDeserialize(): void {
    if (this.paymentFrequency) {
      this.paymentFrequency = window.injector.Deserialize.instanceOf(BaseType, this.paymentFrequency);
    }
  }
}
